import "./style.css"
import "ress"
import { AlertProvider, ThemeProvider } from "matsuri-ui"
import { BrowserRouter } from "react-router-dom"
import { datadogLogs } from "@datadog/browser-logs"
import { datadogRum } from "@datadog/browser-rum"
import { initM2mComponents } from "m2m-components/initM2mComponents"
import ReactDOM from "react-dom/client"
import { cleaningTheme } from "./Theme"
import { App } from "./App"
import { ErrorBoundary } from "@/ErrorBoundary"

const container = document.getElementById("root")

initM2mComponents({
    env: process.env.NODE_ENV === "production" ? "production" : "development"
})

const NODE_ENV = process.env.NODE_ENV ?? "development"

const DATADOG_RELEASE_VERSION = process.env.DATADOG_RELEASE_VERSION

if (DATADOG_RELEASE_VERSION) {
    datadogLogs.init({
        service: `m2m-cleaning-manager-front-${NODE_ENV}`,
        env: NODE_ENV,
        clientToken: "pub8b96652e2b35dcea7c23f96817bca1fb",
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ["error"],
        version: DATADOG_RELEASE_VERSION
    })

    datadogRum.init({
        applicationId: "a7604dd8-f2c6-46a8-b081-62de82e14f1b",
        clientToken: "pub6c840553640a3a67a6e95f63c6be37b8",
        site: "datadoghq.com",
        service: "m2m-cleaning-manager-front",
        env: process.env.RUNTIME_ENV,
        version: DATADOG_RELEASE_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackAnonymousUser: false,
        defaultPrivacyLevel: "mask-user-input"
    })

    datadogRum.startSessionReplayRecording()
}

if (container) {
    const root = ReactDOM.createRoot(container)

    root.render(
        <ThemeProvider theme={cleaningTheme}>
            <ErrorBoundary>
                <BrowserRouter>
                    <AlertProvider position={"bottom-right"}>
                        <App />
                    </AlertProvider>
                </BrowserRouter>
            </ErrorBoundary>
        </ThemeProvider>
    )
}
